// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"FS","skip_info":"GS","skipped":"HS","modify_order":"IS","cancel_subscription_btn":"JS","byb":"KS","modify_order_outer":"LS","byb_edit_btn":"MS","modify_order_item":"NS","cancel_copy_wrapper":"OS","cancelled_copy":"PS"};
    if(module.hot) {
      // 1713969936320
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  